import * as React from "react";
import { useState } from "react";
import ChatContext from "../context/ChatContext";
import { ChatUIStage } from "../types";

interface Props {
  children?: React.ReactNode;
}

export default function ChatProvider(props: Props) {
  const [chatStage, setChatStage] = useState(ChatUIStage.Loading);
  const [closedByAgent, setClosedByAgent] = useState(false);

  const context = {
    chatStage,
    setChatStage,
    closedByAgent,
    setClosedByAgent
  };

  return (
    <ChatContext.Provider value={context}>
      {props.children}
    </ChatContext.Provider>
  );
}
